import { useState } from 'react';

type UseFollowOutput = () => ['auto' | false, (value: boolean) => void];

const useFollowOutput: UseFollowOutput = () => {
    const [hasInteraction, toggleInteraction] = useState<boolean>(false);
    const followOutput = hasInteraction ? false : 'auto';

    const onToggleInteraction = (value: boolean) => {
        toggleInteraction(value);
    };

    return [followOutput, onToggleInteraction];
};

export default useFollowOutput;
